<template>
  <!-- app-sidebar -->
  <div class="app-sidebar">
    <div class="scrollbar-sidebar scrollbar">
      <div class="logo-src">
        <a href="/">
          <img src="@/../assets/imgs/logo-inverse.png" />
        </a>
      </div>
      <div class="app-sidebar__inner">
        <ul class="vertical-nav-menu metismenu">
          <template v-for="(item, index) in menus" :key="index">
            <li v-if="item.type == 'group'" class="app-sidebar__heading">
              {{ item.title }}
            </li>
            <li v-else class="menu-item" :ref="`menuItem-${index}`" @click="clickMenuItem($event, item)">
              <a :href="item.url || '#'">
                <i :class="`metismenu-icon ${item.icon}`"></i>
                {{ item.title }}
              </a>
              <ul v-if="$_.isObjectLike(item.children)" class="sub-menu mm-collapse">
                <template v-for="(itemChild, indexChild) in item.children" :key="indexChild">
                  <li class="menu-item" @click="clickMenuItem($event, itemChild)">
                    <a :href="itemChild.url || '#'">
                      {{ itemChild.title }}
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <div class="current-user widget-content dropdown">
      <div class="dropdown">
        <div data-toggle="dropdown" class="widget-content-wrapper">
          <div class="widget-content-left sidebar-user-avatar">
            <div class="btn-group">
              <a aria-haspopup="true" aria-expanded="false" class="p-0 btn">
                <img width="42" class="rounded-circle" :src="$util.addQueryParam(user?.avatar || avatar, { size: 'xs' })" />
              </a>
            </div>
          </div>
          <div class="widget-content-left ml-3 sidebar-user-info">
            <div class="widget-heading">{{ user?.display_name }}</div>
            <div class="widget-subheading">{{ user?.display_role }}</div>
          </div>
        </div>
        <div tabindex="-1" role="menu" class="dropdown-menu">
          <button type="button" tabindex="0" class="dropdown-item" @click.stop.prevent="$router.push('/edit-profile')">
            <i class="ti ti-user-cog"></i>
            <span>Edit profile</span>
          </button>
          <a href="/logout" tabindex="1" class="dropdown-item">
            <i class="ti ti-logout-2"></i>
            <span>Logout</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <!-- #app-sidebar -->
</template>

<script>
import avatar from '@/../assets/imgs/avatar.png'
export default {
  data() {
    return {
      avatar,
      user: {
        display_name: this,
        display_role: null
      }
    }
  },
  created() {
    this.user = Object.assign(this.user, this.$util.options?.user)
  },
  computed: {
    menus() {
      return this.$util.options.menu
    }
  },
  mounted() {
    this.menuActive()
  },
  methods: {
    menuActive() {
      let $item = document.querySelector(`.app-sidebar a[href$="${this.$route.path}"]`)
      if ($item != null && $item.parentElement != null) {
        $item.parentElement.classList.add('mm-active')
        let $parents = $item.parentElement.parentElement.closest('.menu-item')
        if ($parents != null) {
          $parents.classList.add('mm-active')
          $parents.querySelector('.sub-menu').classList.add('mm-show')
        }
      }
    },
    clickMenuItem(event, item) {
      if (_.isObjectLike(item.children)) {
        event.preventDefault()
        let $subMenu = event.currentTarget.querySelector('.sub-menu')
        if ($subMenu.classList.contains('mm-show')) {
          $subMenu.classList.remove('mm-show')
        } else {
          $subMenu.classList.add('mm-show')
        }
      } else if (_.isString(item.url) && String(item.url).length > 0) {
        let parser = document.createElement('a')
        parser.href = item.url
        let routeName = parser.pathname.replace(/^\/|\/$/g, '')
        let viewName = routeName
          .split('/')
          .map((name) => _.pascalCase(name))
          .join('/')

        if (this.$util.requireOrNull(`/views/*.*/${viewName}/Index.vue`) !== null) {
          event.preventDefault()
          this.$router.push('/' + routeName)
        } else {
          window.location.href = item.url
        }
      }
    }
  }
}
</script>

<style lang="scss">
.app-sidebar {
  height: 100vh;
  margin-top: 0 !important;
  padding-top: 0 !important;
  position: relative;
  padding-bottom: 80px !important;
  .scrollbar-sidebar {
    overflow-y: auto;
    overflow-x: hidden;
  }
  .current-user {
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 999;
    background: #fff;
    min-height: 80px;
    display: flex;
    align-items: center;
    border-top: 1px solid #efefef;
    cursor: pointer;
    user-select: none;
    .dropdown {
      position: static;
    }
    .dropdown-menu {
      margin: 0 0 1px;
      padding: 0;
      bottom: 100%;
      width: 100% !important;
      top: auto !important;
      left: 0 !important;
      border-radius: 0;
      border: 0;
      box-shadow: 0 0;
      border-top: 1px solid #efefef;
      position: absolute !important;
      transform: translateY(0) !important;
    }
    .dropdown-item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #333;
      padding: 10px;
      a {
        color: inherit;
      }
      i {
        font-size: 20px;
        color: #c0c0c0;
        padding: 0 5px 0 0;
        font-weight: bold;
      }
    }
  }
  .sidebar-user-avatar {
    min-width: 42px;
    max-width: 42px;
    height: 42px;
    a,
    img,
    .btn-group {
      display: block;
      width: 100%;
      height: 100%;
    }
    img {
      object-fit: cover;
    }
  }
}
.closed-sidebar {
  &:not(.sidebar-mobile-open) {
    .app-sidebar {
      .current-user {
        justify-content: center;
      }
      .dropdown-menu {
        display: none;
      }
      &:hover {
        .scrollbar-sidebar {
          overflow-y: auto !important;
          overflow-x: hidden;
        }
        .sidebar-user-info {
          display: block;
        }
        .current-user {
          justify-content: start;
        }
        .dropdown-menu.show {
          display: block;
        }
      }
    }
    .sidebar-user-info {
      display: none;
      min-width: 185px;
    }
  }
}
</style>
